module.exports = __webpack_public_path__ + "img/PLAN_APROBADO.36c8a80a.png";